import { TOTAL_DETAIL } from '@/common/stores/slide-detail.logic';
import type { DatabaseDetailType } from './adapters/details.types';

export const DATABASE_DETAIL_TYPE: Record<string, DatabaseDetailType> = {
  SESSION: TOTAL_DETAIL.SESSION,
  SQL: TOTAL_DETAIL.SQL,
  PARAMETER: TOTAL_DETAIL.PARAMETER,
  SLOW_QUERY: TOTAL_DETAIL.SLOW_QUERY,
  OBJECT: TOTAL_DETAIL.OBJECT,
  TRANSACTION: TOTAL_DETAIL.TRANSACTION,
  REPLICATION: TOTAL_DETAIL.REPLICATION,
  REPLICATION_OBJECT: TOTAL_DETAIL.REPLICATION_OBJECT,
  BROKER: TOTAL_DETAIL.BROKER,
  UNRESOLVED_INSTANCE: 'UNRESOLVED_INSTANCE', // 타입(INSTANCE, CLUSTER, SHARDED_CLUSTER) 모르는 상태에서 연계 시 사용
  INSTANCE: TOTAL_DETAIL.INSTANCE,
  CLUSTER: TOTAL_DETAIL.CLUSTER,
  SHARDED_CLUSTER: TOTAL_DETAIL.SHARDED_CLUSTER,
};

export const DOCUMENT_TEXT_TYPE = 'Full Text';
